// extracted by mini-css-extract-plugin
export default {"tabs":"schedule-tabs_tabs__NZD8S","tab":"schedule-tabs_tab__20GyU","active":"schedule-tabs_active__0tHeX"};